import React        from 'react';

export default function Home() {
    return (
        <div>
            HOME PAGE
        </div>
    )
}
